(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-slider-card"] && !Shopify.designMode) return;
  try {
    
	class SliderCard extends HTMLElement {
		connectedCallback() {
			const container = this.querySelector('[data-slider-container]')
			const prevBtn = this.querySelector('[data-prev]')
			const nextBtn = this.querySelector('[data-next]')
			const slides = this.querySelectorAll('[data-slide]')
			const bullets = this.querySelectorAll('[data-bullet]')

			if (!container || !prevBtn || !nextBtn || slides.length === 0) return

			const slideWidth = slides[0].offsetWidth
			const gap = 16

			let isDragging = false
			let startX = 0
			let scrollLeft = 0

			const updateBullets = () => {
				const scroll = container.scrollLeft
				const slideIndex = Math.round(scroll / (slideWidth + gap))

				bullets.forEach((bullet, index) => {
					if (index === slideIndex) {
						bullet.classList.add('is-active')
					} else {
						bullet.classList.remove('is-active')
					}
				})
			}

			const updateButtons = () => {
				const scroll = container.scrollLeft
				const maxScroll = container.scrollWidth - container.clientWidth

				prevBtn.style.opacity = scroll <= 0 ? '0.5' : '1'
				prevBtn.disabled = scroll <= 0

				nextBtn.style.opacity = scroll >= maxScroll - 1 ? '0.5' : '1'
				nextBtn.disabled = scroll >= maxScroll - 1

				updateBullets()
			}

			prevBtn.addEventListener('click', () => {
				container.scrollBy({ left: -(slideWidth + gap), behavior: 'smooth' })
			})

			nextBtn.addEventListener('click', () => {
				container.scrollBy({ left: slideWidth + gap, behavior: 'smooth' })
			})

			container.addEventListener('scroll', updateButtons)

			container.style.cursor = 'grab'

			container.addEventListener('mousedown', (e) => {
				isDragging = true
				container.style.cursor = 'grabbing'
				startX = e.clientX
				scrollLeft = container.scrollLeft
			})

			container.addEventListener('mousemove', (e) => {
				if (!isDragging) return
				e.preventDefault()
				const walk = startX - e.clientX
				container.scrollLeft = scrollLeft + walk
			})

			container.addEventListener('mouseup', () => {
				isDragging = false
				container.style.cursor = 'grab'
			})

			container.addEventListener('mouseleave', () => {
				isDragging = false
				container.style.cursor = 'grab'
			})

			updateButtons()
		}
	}

	if (!customElements.get('slider-card')) {
		customElements.define('slider-card', SliderCard)
	}

  } catch(e) { console.error(e); }
})();
})();
